export default __webpack_public_path__ + "static/media/thrivewings.5a6c5081.jpg";